module.exports = __webpack_public_path__ + "static/img/_1021.27d8116.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_1021.jpg
// module id = 330
// module chunks = 0